import { RouterProvider } from "react-router-dom";
import theme from "./theme";
import router from "./routes";
import { ThirdwebProvider } from "@thirdweb-dev/react";
import { Ethereum } from "@thirdweb-dev/chains";
import { ThemeProvider } from "@mui/styles";
import WalletConnect from "./hooks/thirdwebHooks/WalletConnect";
import RocketFired from "./components/scrollUp";
import { useSelector } from "react-redux";

function App() {
  const { network } = useSelector((state) => state.mint);
  return (
    <ThemeProvider theme={theme}>
      <ThirdwebProvider
        supportedChains={[Ethereum]}
        clientId={"253a907acb5e2a4613158c419761c634"}
        activeChain={JSON.parse(network)}
      >
        <WalletConnect>
          <RouterProvider router={router} />
          <RocketFired />
        </WalletConnect>
      </ThirdwebProvider>
    </ThemeProvider>
  );
}

export default App;
